


  // Function to load Yotpo widget script
  function loadYotpoWidget() {
    var e = document.createElement("script");
    e.type = "text/javascript";
    e.async = true;
    e.src = "//staticw2.yotpo.com/wsG26kigAzwiyrzc4057NIlm4MFuCkXcmCHATbw3/widget.js";
    var t = document.getElementsByTagName("script")[0];
    t.parentNode.insertBefore(e, t);

    // Remove event listeners after first interaction
    document.removeEventListener('click', loadYotpoWidget);
    document.removeEventListener('scroll', loadYotpoWidget);
  }

  // Add event listeners to load script on first click or scroll
  document.addEventListener('click', loadYotpoWidget);
  document.addEventListener('scroll', loadYotpoWidget);

 

window.onload = function(){  
  var x = document.getElementsByClassName("myImage");
  var i;
  for (i = 0; i < x.length; i++) {
    x[i].style.visibility = "visible";
  } 
  
  var menu = document.getElementsByClassName("list-menu--disclosure");
  var j;
  for (j = 0; j < menu.length; j++) {
    menu[j].style.display = "flex";
  } 
} 

